var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"profile"}},[_c('v-divider',{staticClass:"mx-4",attrs:{"vertical":""}}),_c('About'),_c('v-divider',{attrs:{"vertical":""}}),_c('a-divider',{attrs:{"type":"vertical"}}),_c('Skills')],1)}
var staticRenderFns = []

export { render, staticRenderFns }